<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>商品标题：</label>
                <el-input v-model="search_Obj.f_title" clearable></el-input>
            </div>
            <div class="searchGroup">
                <label>所在分类：</label>
                <el-select clearable v-model="search_Obj.f_cat_id" placeholder="请选择">
                    <el-option v-for="item in catTree" :key="'cat_id'+item.id" :label="item.label" :value="item.id+''"></el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>状态：</label>
                <el-select v-model="search_Obj.f_state" clearable placeholder="请选择">
                    <el-option v-for="item in enuObj('goods_state')" :key="'goodsstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
            <!-- <el-switch v-model="search_Obj.is_living" @change="livingChange" active-color="#13ce66" inactive-color="#ff4949" active-text="是否开播" style="margin-left: 20px"></el-switch> -->
            <!-- <el-select v-model="search_Obj.is_living" clearable placeholder="请选择" style="margin-left: 10px;margin-bottom: 10px" @change="livingChange">
                <el-option v-for="item in enuObj('living_type')" :key="'living_type'+item.key" :label="item.title" :value="item.key"> </el-option>
            </el-select> -->
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="id" label="商品ID" sortable="custom" width="120px"></el-table-column>
                <el-table-column prop="title" label="商品名称" sortable="custom"></el-table-column>
                <el-table-column prop="cat_name" label="所在分类" sortable="custom" width="150px"></el-table-column>
                <el-table-column prop="price_min" label="最低价格" sortable="custom" width="120px"></el-table-column>
                <el-table-column prop="sales" label="销量" sortable="custom" width="100px"></el-table-column>
                <el-table-column prop="state" label="状态" sortable="custom" width="100px">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.state, "goods_state") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="900px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="900px"
            :id="model_id"
            title="查看商品"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
        <Spec
            width="800px"
            :goods_id="model_id"
            title="商品规格管理"
            :isshow="specShow"
            @on-close="closeSpecDialog">
        </Spec>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Spec from "../goodsspec/list"
import listutil from "@/libs/listutil"
import { goodsCatData, setLivingState } from '@/api/goodscate'
import { getListData } from '@/api/common'

export default {
    name: 'goodsList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns, Spec},
    data() {
        return {
            m_name: '商品',
            menu_id: 7400,
            list_url: "/api/admin/goods/list",
            search_Obj: {
                f_title: '',
                f_state: '',
                f_is_del: 0,
                is_living: 0
            },
            del_Obj:{
                url:'/api/admin/goods/del',
                data:{
                    ids:''
                }
            },
            catTree: [],
            enu_name: ['goods_state', 'living_type'],
            specShow: false,
        };
    },
    methods: {
        initPageParams() {
            goodsCatData().then(res=>{
                if(res.code == 1){
                    this.catTree = res.data
                }
            })
            this.search_Obj["pageNum"] = this.current;
            this.search_Obj["pageSize"] = this.pagesize;
            if (this.sortData.prop != '') {
                this.search_Obj["sorterName"] = this.sortData.prop;
                this.search_Obj["sorterDirection"] = this.sortData.order;
            }
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.search_Obj.is_living = res.data.is_living+""
                }
            })
        },
        specManager(index, row){
            this.model_id = row.id
            this.specShow = true
        },
        closeSpecDialog() {
            this.specShow = false
            this.getListData()
        },
        livingChange(e){
            let state = e
            setLivingState(state).then(res=>{
                if(res.code ==1){
                    this.$msgs("设置成功");
                }else{
                    this.$msg("设置失败");
                }
            })
        },
    }
};
</script>